import {_ReactPixi, applyDefaultProps, PixiComponent} from '@inlet/react-pixi';
import {Container} from 'pixi.js';
import {ScreenParameters} from '@gongxigames/framework/core/fragments/ScreenParameters';

export type FullscreenCoverProps = Omit<_ReactPixi.IContainer, 'scale'| 'position'> & {
    screenParameters: ScreenParameters;
    position?: [x: number, y: number];
    fixSize?: [width: number, height: number];
};

const NEW_PROPS = Symbol('newProps');
const OLD_PROPS = Symbol('oldProps');

export const FullscreenCover = PixiComponent<FullscreenCoverProps, Container>('FullscreenCover', {
    create(): Container {
        return new Container();
    },

    applyProps(instance: Container, oldProps: FullscreenCoverProps, newProps: FullscreenCoverProps): void {
        instance.name = 'FullscreenCover';

        applyDefaultProps(instance, oldProps, newProps);
        instance.scale.set(1);

        const bounds = instance.getLocalBounds();
        const {fixSize = [bounds.width, bounds.height], position = [0, 0]} = newProps;
        const [newX, newY] = position;
        const [currentWidth, currentHeight] = fixSize;
        const result = newProps.screenParameters.calcScreenFillProps(currentWidth, currentHeight);

        instance.scale.set(result.scale);
        instance.position.set(newX + result.x, newY + result.y);

        (this as any)[NEW_PROPS] = newProps;
        (this as any)[OLD_PROPS] = oldProps;
    },

    didMount(instance: Container, _parent: Container): void {
        const newProps = (this as any)[NEW_PROPS];
        const oldProps = (this as any)[OLD_PROPS];

        this.applyProps?.(instance, oldProps, newProps);
    }
});
